import { api } from "../api/api";
import { ApiResponse } from "../models/base/ApiResponse";
import { GetProductInfoDTO, ProductSettingsListItemDTO } from "../models/product/product.response";


export const productService = {

    async createProduct(localId: string, dto: FormData): Promise<ApiResponse<string>> {
        const { data } = await api.post<ApiResponse<string>>(`/locals/${localId}/products`, dto);
        return data;
    },

    async getProductsByLocalId(localId: string): Promise<ApiResponse<ProductSettingsListItemDTO[]>> {
        const { data } = await api.get<ApiResponse<ProductSettingsListItemDTO[]>>(`/locals/${localId}/products/settings`);
        return data;
    },

    async getProductInfoById(localId: string, productId: string): Promise<ApiResponse<GetProductInfoDTO>> {
        const { data } = await api.get<ApiResponse<GetProductInfoDTO>>(`/locals/${localId}/products/${productId}/settings`);
        return data;
    },

    async UpdateProduct(localId: string, id: string, dto: FormData): Promise<ApiResponse<string>> {
        const { data } = await api.put<ApiResponse<string>>(`/locals/${localId}/products/${id}`, dto);
        return data;
    },

    async deleteProductById(localId: string, productId: string): Promise<ApiResponse<string>> {
        const { data } = await api.delete<ApiResponse<string>>(`/locals/${localId}/products/${productId}`);
        return data;
    }

}